import React from 'react';

const Loging = () => {
    return (
        <div style={{}} className='d-flex justify-content-center align-items-center '>
            <div class="spinner-border  spnerdiv" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    );
};

export default Loging;